import { useRef } from 'react';
import { useDispatch } from 'react-redux';
import { updateReceiptDisplayMode } from '~/actions';
import { Box, Button, Column, Row, Typography } from '@tempmee/react';
import { InputSelect, Label, Pressable } from '~/commonComponents';
import { AnimatedBoxShowHide } from '~/commonComponents/Box';
import { paymentHistoryFilterOptionsLabels } from '~/constants';
import { HideRequestReportButton } from '~/constants/ff.posthog';
import { getShouldEnforcePermanentJobV2 } from '~/services/posthog/FeatureFlagUtils';
import { useFeatureFlag } from '~/hooks/useFeatureFlag';

import { DownloadReportButton } from './DownloadReportButton';
import { OutlineListIcon, OutlineReceiptIcon } from '@tempmee/react-icons';

interface IProps {
  displayMode: string;
  filter: string;
  onFilterChange: (val: string) => void;
  onShowRequestReportPopup: () => void;
}

export const Toolbar = ({
  displayMode,
  filter,
  onFilterChange,
  onShowRequestReportPopup,
}: IProps) => {
  const dispatch = useDispatch();

  const isHideRequestReportButton = useFeatureFlag(HideRequestReportButton);
  const isEnforcePermanentJobV2 = useRef(getShouldEnforcePermanentJobV2()).current;

  return (
    <Row
      align="center"
      data-cy="payment-history-filters"
      style={{ width: '100%', marginTop: 8, marginBottom: 24 }}
    >
      <AnimatedBoxShowHide isShow={displayMode === 'all'}>
        <Row gap={2} align="center">
          <Label text="Transaction Date:" required={false} marginBottom={0} />
          <Box style={{ width: 212 }}>
            <InputSelect
              dataCy="payment-history-filter-dropdown"
              value={filter}
              setValue={onFilterChange}
              isSelectVisible={false}
              options={Object.entries(paymentHistoryFilterOptionsLabels).map(([key, name]) => ({
                value: key,
                title: name,
              }))}
            />
          </Box>
        </Row>
      </AnimatedBoxShowHide>
      <Row align="center" gap={5} style={{ marginLeft: 'auto' }}>
        {!isHideRequestReportButton && (
          <AnimatedBoxShowHide isShow={displayMode === 'all'} style={{ width: 175 }}>
            <Box style={{ height: 32 }} />
            <Button
              data-cy="btn-request-report"
              variant="secondary"
              size="xs"
              onClick={onShowRequestReportPopup}
            >
              Request Report
            </Button>
            <Box style={{ height: 32 }} />
          </AnimatedBoxShowHide>
        )}

        <AnimatedBoxShowHide isShow={displayMode === 'all'}>
          <DownloadReportButton />
        </AnimatedBoxShowHide>

        <Column align="center" style={{ height: 100 }}>
          <Box style={{ height: 32 }} />
          <Row>
            <Pressable onPress={() => dispatch(updateReceiptDisplayMode('shift'))}>
              <Box
                className={`button_group_container_first_option ${
                  displayMode === 'shift' ? 'selected_button_group_option' : ''
                }`}
              >
                <OutlineReceiptIcon />
              </Box>
            </Pressable>
            <div
              onClick={() => dispatch(updateReceiptDisplayMode('all'))}
              className={`button_group_container_last_option ${
                displayMode === 'all' ? 'selected_button_group_option' : ''
              }`}
            >
              <OutlineListIcon />
            </div>
          </Row>
          <Row gapX={5} style={{ marginTop: 5 }}>
            <Typography as="span" style={{ margin: 0 }}>
              {isEnforcePermanentJobV2 ? 'Posting' : 'Shift'}
            </Typography>
            <Typography as="span" style={{ margin: 0 }}>
              All
            </Typography>
          </Row>
        </Column>
      </Row>
    </Row>
  );
};
